import { render, staticRenderFns } from "./RegBasicWrap.vue?vue&type=template&id=2b335cd1"
import script from "./RegBasicWrap.vue?vue&type=script&lang=js"
export * from "./RegBasicWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports